/**
 * Import required libraries
 */
import React from "react";

/**
 * Import required elements
 */
// import Groups from "./groups";
// import Projects from "./projects";
import Privates from "./privates";

export default props => {
  switch (props.category) {
    // case "groups":
    //   return <Groups {...props} />;
    //case "projects":
    //  return <Projects {...props} />;
    case "privates":
      return <Privates {...props} />;
    default:
      throw Error(`Category ${props.category} not defined`);
  }
};
